module.exports = __webpack_public_path__ + "static/media/password-switch-off.e88dd384.svg";